const toastConstants = {
  TOAST_SHOW: "TOAST_SHOW",
  TOAST_REMOVE: "TOAST_REMOVE",
}

export default toastConstants
